<template>
  <layout>
    <div slot="content">
      <i-card title="配置列表">
        <div slot="content">
          <el-table :data="cateList" :border="true">
            <el-table-column prop="title" label="产品名称"></el-table-column>
            <el-table-column prop="min_price" label="最低售价"></el-table-column>
            <el-table-column prop="scenic_score" label="评分"></el-table-column>
            <el-table-column label="操作" width="150">
              <div slot-scope="scope">
                <router-link :to="{name:'settings.soso.edit_config',query:{id:scope.row.id}}">
                  <el-button size="mini" type="primary">编辑</el-button>
                </router-link>
                <el-button size="mini" type="danger" @click="delCate(scope.row.id)">删除</el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <router-link :to="{name:'settings.soso.add_config'}">
            <el-button type="success" size="medium" icon="el-icon-plus">添加配置</el-button>
          </router-link>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
  export default {
    name: "cate",
    data() {
      return {
        cateList: []
      }
    },
    methods: {
      getList: function () {
        this.$http.request('sosoConfigLList').then(res => {
          this.cateList = res.data;
        });
      },
    },
    created: function () {
      this.getList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/soso/config_list.vue